/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWebAuthnVerificationCompleteResponse
 */
export interface OutputWebAuthnVerificationCompleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OutputWebAuthnVerificationCompleteResponse
     */
    success?: boolean;
}

/**
 * Check if a given object implements the OutputWebAuthnVerificationCompleteResponse interface.
 */
export function instanceOfOutputWebAuthnVerificationCompleteResponse(value: object): boolean {
    return true;
}

export function OutputWebAuthnVerificationCompleteResponseFromJSON(json: any): OutputWebAuthnVerificationCompleteResponse {
    return OutputWebAuthnVerificationCompleteResponseFromJSONTyped(json, false);
}

export function OutputWebAuthnVerificationCompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWebAuthnVerificationCompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function OutputWebAuthnVerificationCompleteResponseToJSON(value?: OutputWebAuthnVerificationCompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'success': value['success'],
    };
}

